import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'
import { employmentTypes } from 'modules/contracts/lib/germanContractData'

interface Props {
  employmentTypeId?: number | null
}

const EmploymentType = ({ employmentTypeId }: Props) => {
  const employmentType = employmentTypeId ? employmentTypes()[employmentTypeId] : undefined

  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.germany.employment_type')}
      description={employmentType}
    />
  )
}

export default observer(EmploymentType)
